<script>
    import Papa from "papaparse";
    import { saveAs } from "file-saver";

    import ClosedOrderItem from "./ClosedOrderItem.svelte";
    import { order } from "../bl/order-bl";

    export let orders;

    function downloadCSV() {
        let csvData = [];

        orders.forEach((order) => {
            let createdAt = new Date(order.createdAt.seconds * 1000);
            let createdAtFormatted = `${createdAt.getFullYear()}-${createdAt.getMonth()}-${createdAt.getDate()}`;

            let orderItems = [];
            order.items.forEach((item) => {
                orderItems.push(`${item.count}x${item.name}: ${item.price}`);
            });

            csvData.push({
                categories: order.categories,
                createdAt: createdAtFormatted,
                items: orderItems,
                sum: order.sum,
            });
        });

        const dataString = Papa.unparse(csvData);
        const blob = new Blob([dataString], { type: "text/csv;charset=utf-8" });
        saveAs(blob, "myfile.csv");
    }

</script>

{#if orders}
    <div class="closedOrders">
        <button on:click={downloadCSV}>הורדה לקובץ CSV</button>
        {#each orders as order, idx}
            <ClosedOrderItem {order} {idx} showDetails={false} />
        {/each}
    </div>
{/if}

<style>
    .closedOrders {
        border-radius: 10px;
        background: #ffffff;
        padding: 10px;
        box-sizing: border-box;
        width: 100%;
        table-layout: fixed;
        box-shadow: 0 3px 10px -10px;
        max-width: 800px;
        margin: 0 auto;
    }

</style>
